import { inputTypes } from '../helpers/enums';

const userRoles = [
  {
    value: 'admin',
    label: 'Admin',
  },
  {
    value: 'employee',
    label: 'Employee',
  }
];

const commonForm = {
  email: {
    label: 'Email',
    type: inputTypes.email,
    placeholder: 'Enter email',
    validation: {
      required: true,
      pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i
    },
  },
  password: {
    label: 'Password',
    type: inputTypes.password,
    placeholder: 'Enter password',
    validation: {
      required: true,
      minLength: 6
    }
  },
  name: {
    label: 'Name',
    type: inputTypes.text,
    placeholder: 'Enter name',
    validation: {
      required: true,
      minLength: 2
    }
  },
  role: {
    label: 'Role',
    type: inputTypes.select,
    placeholder: 'Select role',
    validation: {
      required: true,
    },
    options: userRoles
  },
  hourlyRate: {
    label: 'Hourly Rate',
    type: inputTypes.number,
    placeholder: 'Enter hourly rate',
    validation: {
      min: 0
    },
  },
  monthlyRate: {
    label: 'Monthly Rate',
    type: inputTypes.number,
    placeholder: 'Enter monthly rate',
    validation: {
      min: 0
    }
  },
};

export const newEmployeeForm = {
  ...commonForm,
};

export const employeeForm = {
  ...Object.entries(commonForm).reduce((acc, [key, value]) => {
    if (key !== 'password') {
      acc[key] = value;
    } else {
      acc[key] = {
        ...value,
        label: 'New password',
        validation: {
          ...value.validation,
          required: false
        }
      }
    }
    return acc;
  }, {}),
};
